import VanillaTilt from "vanilla-tilt";

export default {
  mounted(el, binding) {
    const options = binding.value || {
      max: 15,
      speed: 400,
      glare: true,
      "max-glare": 0.2,
      scale: 1.05,
    };
    VanillaTilt.init(el, options);
  },
  beforeUnmount(el) {
    if (el.vanillaTilt) {
      el.vanillaTilt.destroy();
    }
  },
};
